<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="采购单" v-if="findChildren(56)!==-1" name="wlnpurchase" style="height: 100%;">
				<wlnpurchase-index />
			</el-tab-pane>
			<el-tab-pane label="代发单" v-if="findChildren(135)!==-1" name="agencysendwarehouse" style="height: 100%;">
				<agencysendwarehouse-index />
			</el-tab-pane>
			<el-tab-pane label="采购凭证" v-if="findChildren(109)!==-1" name="purchasevoucher" style="height: 100%;">
				<purchasevoucher-index />
			</el-tab-pane>	
			<el-tab-pane label="非标工单" v-if="findChildren(112)!==-1" name="wlnpurchaseworkorder" style="height: 100%;">
				<wlnpurchaseworkorder-index />
			</el-tab-pane>			
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import wlnpurchaseIndex from './wlnpurchase/index.vue'
	import agencysendwarehouseIndex from './agencysendwarehouse/index.vue'
	import wlnpurchaseworkorderIndex from './wlnpurchaseworkorder/index.vue'
	import purchasevoucherIndex from './purchasevoucher/index.vue'

	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			wlnpurchaseIndex,
			wlnpurchaseworkorderIndex,
			purchasevoucherIndex,
			agencysendwarehouseIndex

		}
	}
</script>